document.querySelectorAll(".tab_content").forEach((tab, index) => {
   if (index === 0) {
      tab.style.display = "block"
   } else {
      tab.style.display = "none"
   }
})

document.querySelectorAll("ul.tabs li").forEach(function (tab) {
   tab.addEventListener("click", function () {
      document.querySelectorAll(".tab_content").forEach(function (content) {
        content.classList.remove("content__visible")
        content.classList.remove("content__invisible")
         content.style.display = "none";
      });

      var activeTab = this.getAttribute("rel");
      document.getElementById(activeTab).style.display = "block";
      document.querySelectorAll("ul.tabs li").forEach(function (tab) {
         tab.classList.remove("active");
      });

      this.classList.add("active");

      document.querySelectorAll(".tab_drawer_heading").forEach(function (heading) {
         heading.classList.remove("d_active");
      });

     var tabHeading = document.querySelector(".tab_drawer_heading[rel^='" + activeTab + "']");
    if (tabHeading) {
        tabHeading.classList.add("d_active");
    } 

   });
});



document.querySelectorAll(".tab_drawer_heading").forEach(function (heading) {
   heading.addEventListener("click", function (e) {
     e.preventDefault();
      var d_activeTab = this.getAttribute("rel");
      document.querySelectorAll(".tab_content").forEach(function (content) {
         if (content.id == d_activeTab) {
            if (content.classList.contains("content__visible")) {
               content.classList.remove("content__visible")
               content.classList.add("content__invisible")
            } else {
               content.classList.remove("content__invisible")
               content.classList.add("content__visible")
               var scrollDiv = document.getElementById(`id-${d_activeTab}`).offsetTop;
               window.scrollTo({
                  top: scrollDiv,
                  behavior: 'smooth'
               });
            }
         } else {
            content.classList.remove("content__visible")
            content.classList.add("content__invisible")
         }
      });


      document.querySelectorAll(".tab_drawer_heading").forEach(function (heading) {
         heading.classList.remove("d_active");
      });


      this.classList.add("d_active");

      document.querySelectorAll("ul.tabs li").forEach(function (tab) {
         tab.classList.remove("active");
      });

      document.querySelector("ul.tabs li[rel^='" + d_activeTab + "']").classList.add("active");
   });
});

document.querySelector("ul.tabs li:last-child").classList.add("tab_last");
